/**
 * Callback Page
 * Redirects back from Auth0 after login
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Container, Typography } from '@mui/material';

export function CallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Give Auth0 a moment to process, then redirect to email gate
    const timer = setTimeout(() => {
      navigate('/email-gate');
    }, 500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography>Signing in...</Typography>
      </Box>
    </Container>
  );
}
